export default function Testimonials() {
  const studentVoices = [
    {
      name: 'Kさん',
      grade: '中学3年生(広島県立高校合格)',
      comment: '中2の冬まで数学が苦手で模試でもD判定でしたが、NICKで基礎から徹底的にやり直したおかげで、受験本番では自信を持って解くことができました。第一志望の県立高校に合格できて本当に嬉しいです!',
    },
    {
      name: 'Sさん',
      grade: '中学3年生(私立高校特進コース合格)',
      comment: '部活を引退してからの半年間、NICKで毎日のように勉強しました。先生が自分に合った学習計画を立ててくれたので、効率よく勉強できました。苦手だった英語も得点源になり、特進コースに合格できました!',
    },
    {
      name: 'Mさん',
      grade: '中学3年生(第一志望校合格)',
      comment: '最初は偏差値が志望校に全然届いていなくて不安でしたが、先生が「大丈夫、一緒に頑張ろう」と言ってくれて心強かったです。分からないところを何度でも丁寧に教えてもらえたおかげで、無事に合格できました!',
    },
  ];

  const parentVoices = [
    {
      name: 'Kさんの保護者様',
      grade: '中学3年生の母',
      comment: '受験期は親子ともに不安でしたが、先生が定期的に面談をしてくださり、子どもの学習状況や志望校対策を丁寧に説明してくれました。おかげで安心して見守ることができ、志望校合格という最高の結果を得られました。',
    },
    {
      name: 'Yさんの保護者様',
      grade: '中学3年生の父',
      comment: '家では全く勉強しなかった息子が、NICKに通い始めてから自分から机に向かうようになりました。先生方の熱心な指導のおかげで成績がぐんぐん伸び、合格発表の日は家族全員で喜びました。本当に感謝しています。',
    },
    {
      name: 'Rさんの保護者様',
      grade: '中学3年生の母',
      comment: '娘は人見知りで塾が続くか心配でしたが、先生方がとても親しみやすく、すぐに馴染めたようです。受験直前の追い込み時期も精神面でサポートしていただき、見事第一志望に合格。NICKを選んで本当に良かったです。',
    },
  ];

  return (
    <section className="py-16 md:py-24 px-6 md:px-12 bg-[#F5F5F7]">
      <div className="max-w-lg md:max-w-4xl lg:max-w-6xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <div className="inline-flex items-center gap-2 text-[#1A2B4A] mb-3">
            <i className="ri-chat-3-line text-xl"></i>
            <span className="text-sm font-medium tracking-wider uppercase">VOICE</span>
          </div>
          <h2 className="text-[32px] md:text-[40px] font-bold text-[#1A2B4A]">
            生徒・保護者の声
          </h2>
        </div>

        <div className="mb-8">
          <h3 className="text-xl font-bold text-[#1A2B4A] mb-5 flex items-center gap-2">
            <span className="w-8 h-8 flex items-center justify-center bg-[#1A2B4A] text-white rounded-full text-sm">
              <i className="ri-user-line"></i>
            </span>
            生徒の声
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {studentVoices.map((voice, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-6 shadow-sm"
              >
                <div className="mb-4">
                  <div className="text-[#1A2B4A] font-bold text-lg mb-1">{voice.name}</div>
                  <div className="text-[#6B7280] text-sm">{voice.grade}</div>
                </div>
                <p className="text-[#1A2B4A] text-sm leading-relaxed">
                  {voice.comment}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div>
          <h3 className="text-xl font-bold text-[#1A2B4A] mb-5 flex items-center gap-2">
            <span className="w-8 h-8 flex items-center justify-center bg-[#E8913A] text-white rounded-full text-sm">
              <i className="ri-parent-line"></i>
            </span>
            保護者の声
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {parentVoices.map((voice, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-6 shadow-sm"
              >
                <div className="mb-4">
                  <div className="text-[#1A2B4A] font-bold text-lg mb-1">{voice.name}</div>
                  <div className="text-[#6B7280] text-sm">{voice.grade}</div>
                </div>
                <p className="text-[#1A2B4A] text-sm leading-relaxed">
                  {voice.comment}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
